import React from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import "./epg.scss";

const EPGPartnerCard = ({ partner, onFocus, onEnterPress, index, rowId }) => {
    const { id, name, defaultLogo, logo } = partner;
    const focusKey = `partner-${rowId}-${index}`;

    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress,
        onFocus: (focusProps) => {
            onFocus({
                ...focusProps,
                index,
            });
        },
        extraProps: {
            focusKey: id,
        },
    });

    return (
        <div ref={ref} className={`partnerCard ${focused ? "partnerCardFocused" : ""}`} onClick={() => onEnterPress({ focusKey: id })}>
            <button 
                aria-label={`Filter by ${name}`} 
                className="partnerCardButton" 
                style={{ backgroundImage: `url(${focused ? logo : defaultLogo})` }}
            />
        </div>
    );
};

export default EPGPartnerCard;
